import { render, staticRenderFns } from "./DriversLicenseModal.vue?vue&type=template&id=47afeb92&scoped=true"
import script from "./DriversLicenseModal.vue?vue&type=script&lang=js"
export * from "./DriversLicenseModal.vue?vue&type=script&lang=js"
import style0 from "./DriversLicenseModal.vue?vue&type=style&index=0&id=47afeb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afeb92",
  null
  
)

export default component.exports